import { render, staticRenderFns } from "./DetallesEvento.vue?vue&type=template&id=732f2342&"
import script from "./DetallesEvento.vue?vue&type=script&lang=js&"
export * from "./DetallesEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports